import portal from 'core/assets/svg/portal.svg';
import contact from 'core/assets/svg/contact.svg';
import pieChart from 'core/assets/svg/pie-chart.svg';
import pen from 'core/assets/svg/pen.svg';
import tool from 'core/assets/svg/tool.svg';
import puzzlePiece from 'core/assets/svg/puzzle-piece.svg';
import lifeInsurance from 'core/assets/svg/life-insurance.svg';
import claim from 'core/assets/svg/claim.svg';

// IMPORTANT
// If adding OR changing links in this constant, please reach out to
// John Magee or Christie Brandao who have access to our paid embednotion account
// otherwise, if the link is from an unpaid account, it will not show up how users expect

export default [
  {
    route: 'updates',
    src: 'https://www.notioniframe.com/notion/u7p912hkzh',
    title: 'Updates',
    iconSrc: portal
  },
  {
    route: 'reports-and-commissions',
    src: 'https://www.notioniframe.com/notion/2n5ljmi0ssx',
    title: 'Reports & Commissions',
    iconSrc: pieChart
  },
  {
    route: 'underwriting',
    src: 'https://www.notioniframe.com/notion/2oo802mgfbi',
    title: 'Underwriting',
    iconSrc: pen
  },
  {
    route: 'tools',
    src: 'https://www.notioniframe.com/notion/20y8zrpsyy2',
    title: 'Resources',
    iconSrc: tool
  },
  {
    route: 'training',
    src: 'https://www.notioniframe.com/notion/1s31qzhvy4w',
    title: 'Training',
    iconSrc: puzzlePiece
  },
  {
    route: 'life-insurance',
    src: 'https://www.notioniframe.com/notion/2lwkl3rox24',
    title: 'Life Insurance',
    iconSrc: lifeInsurance
  },
  {
    route: 'claims',
    src: 'https://www.notioniframe.com/notion/aoq2ldtalvo',
    title: 'Claims',
    iconSrc: claim
  },
  {
    route: 'contact-us',
    src: 'https://www.notioniframe.com/notion/1cuxb9z5kkc',
    title: 'Contact Us',
    iconSrc: contact
  }
];
